export default __webpack_public_path__ + "static/media/proforma-logo.f74d260d.jpeg";